(function($) {

  if( $(".block-faq-section-item .faq-title").hasClass('is-open') ){
    $(".block-faq-section-item .faq-title.active").closest('.block-faq-section-item').find('.faq-content').show();
  }
  $(".block-faq-section-item .faq-title").click(function(){
    if( $(this).hasClass('active') ){
      $(this).removeClass("active").closest('.block-faq-section-item').find('.faq-content').slideUp(200);
    }
    else{	$(this).addClass("active").closest('.block-faq-section-item').find('.faq-content').slideDown(200);
  }
  });

})(jQuery);